import { render, staticRenderFns } from "./TestDataStatistc.vue?vue&type=template&id=bf07b42a"
import script from "./TestDataStatistc.vue?vue&type=script&lang=js"
export * from "./TestDataStatistc.vue?vue&type=script&lang=js"
import style0 from "./TestDataStatistc.vue?vue&type=style&index=0&id=bf07b42a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports